module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kca_m2.ed233baac9721c0124d06bc2613e9fa5.png";